import { FormControlLabel, Link, Stack, Switch, Typography } from "@mui/material";

import { winnersCopy } from "../config/appCopy";
import { glassPanelSx } from "./glassPanel";

interface MatchupToolbarProps {
  resolved: number;
  total: number;
  hideResolved: boolean;
  onToggleHideResolved: (hide: boolean) => void;
  onGoToLatest?: () => void;
}

const stripTextSx = { color: "text.primary", fontWeight: 500 } as const;

export function MatchupToolbar({
  resolved,
  total,
  hideResolved,
  onToggleHideResolved,
  onGoToLatest,
}: MatchupToolbarProps): JSX.Element {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{ ...glassPanelSx, px: { xs: 1.5, sm: 2 }, py: 1 }}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="body2" sx={stripTextSx}>
          {`${resolved} / ${total} resolved`}
        </Typography>
        {onGoToLatest && (
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={onGoToLatest}
            sx={stripTextSx}
          >
            {winnersCopy.goToLatestLabel}
          </Link>
        )}
      </Stack>
      <FormControlLabel
        control={
          <Switch
            checked={hideResolved}
            onChange={(event) => onToggleHideResolved(event.target.checked)}
          />
        }
        label="Hide resolved"
        slotProps={{ typography: { variant: "body2", sx: stripTextSx } }}
      />
    </Stack>
  );
}
